import { CardContent, Typography } from '@mui/material';
import StyledCardNoHeight from '../../components/card/StyledCardNoHeight';
import Theme from '../../layouts/theme/Theme';

export default function AppearanceSettings() {
  const ONLY_ICON = false;

  return (
    <StyledCardNoHeight>
      <CardContent>
        <Typography variant="h6" sx={{ color: 'darkgray' }}>
          መልክ
        </Typography>
        <Typography sx={{ mt: 2 }}>
          <Theme ONLY_ICON={ONLY_ICON} />
        </Typography>
      </CardContent>
    </StyledCardNoHeight>
  );
}
